import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=2d50d3ea&scoped=true&lang=pug"
import script from "./Confirm.vue?vue&type=script&lang=js"
export * from "./Confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d50d3ea",
  null
  
)

export default component.exports